const CameraInput = ({ field, setFieldValue, values }) => {
    return (
      <div className="border-2 border-dashed border-gray-300 rounded-lg p-4 text-center">
        {field.Capture(setFieldValue, values)}
      </div>
    );
  };
  
  export default CameraInput;